import { useSupportChatStore } from '../supportChatStore.ts';
import { clearInMemoryData } from '../Salesforce/services/dataProvider.ts';

function clearSupportChatData(): void {
    const store = useSupportChatStore.getState();
    store.resetStore({ resetStorage: true });
    clearInMemoryData();
}

export { clearSupportChatData };
